import { BankAccountUpdatePage } from '@/features/bank-account/pages/BankAccountUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/bank-account/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["bank_account.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BankAccountUpdatePage,
});
